import React from "react";
import {Redirect, Route, Switch} from "react-router";
import {ROUTES} from "../../db/models/const";
import {CompanyDashboard} from "./Dashboard";
import {CompanyProfile} from "./Profile";
import {CompanyRmManage} from "./RmManage";
import CompanySettings from "./Settings";
import "./style.scss";

export const CompanyMain = () => {
    return (
        <section className="main">
            <Switch>
                <Route path={ROUTES.ME} exact>
                    <CompanyDashboard/>
                </Route>
                <Route path={ROUTES.PROFILE} exact>
                    <CompanyProfile/>
                </Route>
                <Route path={ROUTES.COMPANY_RM} component={CompanyRmManage}/>
                <Route path={ROUTES.SETTINGS} exact component={CompanySettings}/>

                <Redirect to={ROUTES.ME}/>
            </Switch>
        </section>
    );
};
